// Applies random scale and rotation to all .bus-gallery__item:not(:first-child) on mobile/tablet screens
function applyGalleryRandomTransforms() {
    // Only run on screens smaller than 992px (matches $lg breakpoint)
    if (window.innerWidth >= 992) {
        // On desktop: remove any previously applied transforms (for when resizing up)
        var items = document.querySelectorAll('.bus-gallery__item:not(:first-child)');
        items.forEach(function (item) {
            item.style.transform = '';
        });
        return;
    }
    // Get the gallery list container
    var galleryList = document.querySelector('.bus-gallery__list');
    if (!galleryList) return;

    // Select all gallery items except the first one
    var items = galleryList.querySelectorAll('.bus-gallery__item:not(:first-child)');
    if (!items.length) return;

    // Apply random scale and rotation to each item
    items.forEach(function (item) {
        // Get the scale value from CSS variable, fallback to 1.05
        var scale = getComputedStyle(item).getPropertyValue('--scale-mobile-value') || '1.05';
        // Generate a random degree between -10 and 10
        var randomDeg = (Math.random() * 20 - 10).toFixed(2);
        // Apply the transform
        item.style.transform = `scale(${scale}) rotate(${randomDeg}deg)`;
    });
}

// Debounce function: ensures applyGalleryRandomTransforms is not called too frequently on resize
function debounce(func, wait) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
    };
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', applyGalleryRandomTransforms);
// Run on window resize, debounced for performance
window.addEventListener('resize', debounce(applyGalleryRandomTransforms, 150));
